var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"l-navigationmain navigationmain",attrs:{"role":"navigation","aria-label":"navigation"}},[_c('ul',_vm._l((_vm.links),function(link,i){return _c('display-menu',{key:i + '-' + link.routeName,attrs:{"link":link}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-033c2049","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/LayoutLeftMenu.vue
// module id = null
// module chunks = 